var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "navbar navbar-light navbar-expand-lg" },
    [
      _vm._t("logo"),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "navbar-toggler",
          attrs: {
            type: "button",
            "data-toggle": "collapse",
            "data-target": "#" + _vm.id,
            "aria-controls": _vm.id,
            "aria-expanded": "false"
          }
        },
        [
          _c("span", { staticClass: "sr-only" }, [
            _vm._v(_vm._s(_vm.$t("Menu.NavigationMenu")))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "navbar-toggler-icon" })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "collapse navbar-collapse", attrs: { id: _vm.id } },
        [
          _c(
            "ul",
            { staticClass: "navbar-nav mr-auto" },
            [
              _vm._l(_vm.routes, function(route, index) {
                return _c(
                  "li",
                  { staticClass: "nav-item" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "nav-link",
                        attrs: {
                          "aria-label": _vm.$t(route.meta.title),
                          to: { name: route.name },
                          "aria-current": _vm.isCurrentRoute(route.name)
                            ? "page"
                            : false
                        }
                      },
                      [
                        _c("span", [_vm._v(_vm._s(_vm.$t(route.meta.title)))]),
                        _vm._v(" "),
                        _vm.showBadge(route)
                          ? _c("span", { staticClass: "badge badge-primary" }, [
                              _vm._v(_vm._s(_vm.getBadgeValue(route)))
                            ])
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c("li", { staticClass: "nav-item" }, [_vm._t("link1")], 2),
              _vm._v(" "),
              _c("li", { staticClass: "nav-item" }, [_vm._t("link2")], 2),
              _vm._v(" "),
              _c("li", { staticClass: "nav-item" }, [_vm._t("link3")], 2)
            ],
            2
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }